import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const MentionsLegales = () => {
  return (
    <div className="min-h-screen bg-white">
      <header className="border-b border-gray-200">
        <div className="max-w-4xl mx-auto px-6 py-6">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-gray-600 hover:text-blue-600 transition-colors"
            data-testid="back-to-home-link"
          >
            <ArrowLeft className="w-4 h-4" />
            Retour à l'accueil
          </Link>
        </div>
      </header>
      
      <main className="max-w-4xl mx-auto px-6 py-16">
        <h1 className="text-4xl font-bold text-gray-900 mb-8 font-['Manrope']">
          Mentions légales
        </h1>
        
        <div className="prose prose-gray max-w-none space-y-8">
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4 font-['Manrope']">
              Éditeur du site
            </h2>
            <p className="text-gray-600 leading-relaxed">
              <strong>Raison sociale :</strong> Performance Transmission Sàrl<br />
              <strong>Adresse :</strong> Tolochenaz, VD, Suisse<br />
              <strong>Email :</strong> compta@performancetransmission.ch<br />
              <strong>Représentant légal :</strong> Corinne Lelogeay
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4 font-['Manrope']">
              Activité
            </h2>
            <p className="text-gray-600 leading-relaxed">
              Performance Transmission Sàrl est une fiduciaire proposant des services de comptabilité, 
              de déclarations fiscales et de conseil financier aux particuliers et entreprises en Suisse.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4 font-['Manrope']">
              Droit applicable
            </h2>
            <p className="text-gray-600 leading-relaxed">
              Le site s'adresse exclusivement à des clients en Suisse. Les présentes mentions légales 
              sont soumises au droit suisse (LPD — Loi fédérale sur la protection des données).
            </p>
          </section>
        </div>
      </main>
      
      <footer className="border-t border-gray-200 py-8">
        <div className="max-w-4xl mx-auto px-6 text-center text-gray-500 text-sm">
          © 2025 Performance Transmission Sàrl. Tous droits réservés.
        </div>
      </footer>
    </div>
  );
};

export default MentionsLegales;
